import { create } from 'zustand';

type QuizScrollStore = {
  scrollToIndexFn?: (index: number, behavior?: ScrollBehavior) => void;
  setScrollToIndexFn: (fn?: (index: number, behavior?: ScrollBehavior) => void) => void;
  scrollToTopFn?: (behavior?: ScrollBehavior) => void;
  setScrollToTopFn: (fn?: (behavior?: ScrollBehavior) => void) => void;
  scrollTo: (index: number) => void;
};

export const useQuizScroll = create<QuizScrollStore>((set, get) => ({
  setScrollToIndexFn: fn => set({ scrollToIndexFn: fn }),
  setScrollToTopFn: fn => set({ scrollToTopFn: fn }),
  scrollTo: index => {
    const scrollToIndex = get().scrollToIndexFn;
    if (scrollToIndex) {
      const virtualIndex = index + 1;
      scrollToIndex(virtualIndex, 'smooth');
      return;
    }
    const el = document.querySelector<HTMLElement>(`[data-question-index="${index}"]`);
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}));
